<template>
  <el-collapse-item :name="name">
    <template slot="title">
      <div class="collapse-title">
        <div>
        <span>{{license.name}}
          <p>({{license.key}}) </p>
          </span>
        </div>
        <div>
          <span>
            <el-tooltip class="item" effect="dark" :content="$t('gotogooglemaps')" placement="bottom-start" v-if="$route.name === 'dashboard'">
              <a @click="goToGoogleMaps(license.lat, license.lon)">
                {{license.street}} {{license.houseNumber}} {{license.postCode}} {{license.city}} {{license.country}}
                <p>({{license.lat}}, {{license.lon}})</p>
              </a>
            </el-tooltip>
          </span>
        </div>
        <div style="margin-right: 0.3rem">
          <el-tooltip class="item" effect="dark" :content="$t('gotoroomsconfig')" placement="bottom-start" v-if="$route.name === 'dashboard'">
            <el-button round size="mini" @click="goToMesqtt($event, license)">
              {{$t('gotomesqtt')}}
              <i class="el-icon-arrow-right el-icon-right"></i>
            </el-button>
          </el-tooltip>
            <i
            style="margin-right: 0.3rem"
              :class="{
            'ion-md-bug text-warning': license.bugStatus
          }"
            ></i>
          <el-tooltip class="item" effect="dark" :content="$t('deviceconnection')" placement="bottom-start" v-if="$route.name === 'dashboard'">
            <i
              :class="{
                'el-icon-success': license.status === 'OK',
                'text-success': license.status === 'OK',
                'el-icon-error': license.status === 'ERROR',
                'text-danger': license.status === 'ERROR',
                'el-icon-question': license.status === 'UNKNOWN',
                'text-info': license.status === 'UNKNOWN',
                'el-icon-warning': license.status === 'WARNING',
                'text-warning': license.status === 'WARNING'
              }"
            ></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="license-details">
      <!-- <h3>{{ license.grid }}</h3> -->
      <small v-if="devices.length">{{$t('lastmessage')}} {{ elapsed(status) }}</small>
      <el-table :data="devices" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand" v-for="node in props.row.nodes" :key="node.id">
              <h4>
                <i
                  :class="{
                    'el-icon-success text-success': node.lastError == null || node.lastError + 1000 * 60 * 60 < Date.now(),
                    'el-icon-warning text-warning': !(node.lastError == null || node.lastError + 1000 * 60 * 60 < Date.now())
                  }"
                ></i>
                {{ node.id }}
              </h4>
              <div v-show="node.lastError">{{ $t('lastproblem') }} {{ lastElapsed(node.lastError) }}</div>
              <el-table :data="node.properties">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="value" :label="$t('values')">
                  <template slot-scope="scope">
                    <div v-for="(value, index) in scope.row.value" :key="index">
                      <el-row v-if="value != null">
                        <el-col v-if="scope.row.value.length > 1" :xs="6">{{index}}:</el-col>
                        <el-col :xs="scope.row.value.length > 1 ? 18 : 24">{{value}}</el-col>
                      </el-row>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="uptime" label="Uptime">
          <template slot-scope="scope">{{ scope.row.uptime | since }}</template>
        </el-table-column>
          <el-table-column prop="online" label="Is online?">
            <template slot="header">
              <el-tooltip class="item" effect="dark" :content="$t('isdeviceisonline')" placement="bottom-start" v-if="$route.name === 'dashboard'">
                <i class="ion-md-wifi"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <i
                :class="{
                'el-icon-success text-success': scope.row.online,
                'el-icon-error text-danger': !scope.row.online
              }"
              ></i>
            </template>
          </el-table-column>
        <el-table-column prop="lastError" label="Last error">
          <template slot="header">
            <el-tooltip class="item" effect="dark" :content="$t('correctOperation')" placement="bottom-start" v-if="$route.name === 'dashboard'">
              <i class="ion-md-bug"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <i
              :class="{
              'el-icon-success text-success': scope.row.lastError == null || scope.row.lastError + 1000 * 60 * 60 < Date.now(),
              'el-icon-warning text-warning': !(scope.row.lastError == null || scope.row.lastError + 1000 * 60 * 60 < Date.now())
            }"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="lastMessage" :label="$t('lastmessageat')">
          <template slot-scope="scope"> {{ scope.row.lastPublish ? new Date(scope.row.lastPublish).toLocaleString() : ""}}</template>
        </el-table-column>
      </el-table>
    </div>
  </el-collapse-item>
</template>

<script>
import { UserStore, MqttStore } from "@/store";
import mpat from "mqtt-pattern";
import { setInterval, clearInterval } from "timers";

export default {
  name: "LicenseDevices",
  props: ["license", "name"],
  filters: {
    since(seconds) {
      if (!seconds) return "";

      if (seconds < 60) {
        return `od ${seconds} s`;
      }
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return `od ${minutes} min`;
      }
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return `od ${hours} h`;
      }
      const days = Math.floor(hours / 60);
      if (days < 24) {
        return `od ${days} d`;
      }
    }
  },
  methods: {
    elapsed(value) {
      if (!value) return "";

      const seconds = Math.floor(value / 1000);
      if (seconds < 60) {
        return `${seconds} ${this.$t('secondsago')}`;
      }
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return `${minutes} ${this.$t('minutesago')}`;
      }
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return `${hours} ${this.$t('hoursago')}`;
      }
    },
    lastElapsed(value) {
      if (!value) return "";

      value = Date.now() - value;
      const seconds = Math.floor(value / 1000);
      if (seconds < 60) {
        return `${seconds} ${this.$t('secondsago')}`;
      }
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return `${minutes} ${this.$t('minutesago')}`;
      }
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return `${hours} ${this.$t('hoursago')}`;
      }
    },
    goToMesqtt(event, license) {
      event.preventDefault();
      event.stopPropagation();
      console.log(event, license);
      window.sessionStorage.setItem('acloud_username', `${this.$store.user.state.username}`);
      window.sessionStorage.setItem('acloud_grid', `/${this.$store.user.state.username}/${license.grid}/`);
      window.sessionStorage.setItem('acloud_protocol', `${this.$store.mqtt.state.cli.options.protocol}`);
      window.sessionStorage.setItem('acloud_host', `${this.$store.mqtt.state.cli.options.hostname}`);
      window.sessionStorage.setItem('acloud_port', `${this.$store.mqtt.state.cli.options.port}`);
      window.sessionStorage.setItem('acloud_path', `${this.$store.mqtt.state.cli.options.path}`);
      window.location.replace('/mesqtt/');
    },
    goToGoogleMaps(lat, lon) {
      let latLetter = 'N';
      let lonLetter = 'E';
      if (parseFloat(lat) < 0) {
        lat = (parseFloat(lat) * -1).toString()
        latLetter = 'S';
      }
      if (parseFloat(lon) < 0) {
        lon = (parseFloat(lon) * -1).toString()
        lonLetter = 'W';
      }
      let split1 = lat.split('.');
      let split2 = lon.split('.');
      let latDeg = split1[0];
      let lonDeg = split2[0];
      split1 = (parseFloat(`0.${split1[1]}`) * 60).toString().split('.');
      split2 = (parseFloat(`0.${split2[1]}`) * 60).toString().split('.');
      let latMin = split1[0];
      let lonMin = split2[0];
      let latSec = parseFloat(`0.${split1[1]}`) * 60;
      let lonSec = parseFloat(`0.${split2[1]}`) * 60;
      let url = `https://www.google.pl/maps/place/${latDeg}°${latMin}'${latSec}"${latLetter}+${lonDeg}°${lonMin}'${lonSec}"${lonLetter}/@${lat},${lon}z`
      window.location.href = url;
    },
    getStatus() {
      this.status =
        Date.now() -
        this.devices.reduce(
          (acc, curr) => Math.max(curr.lastPublish ? curr.lastPublish : 0, acc), 0
        );
    },
    updateStatus() {
      this.$nextTick(() => {
        this.$emit(
          "status",
          this.devices.reduce(
            (acc, curr) => ({
              ...acc,
              isFine: curr.online && acc.isFine,
              ok: curr.online ? ++acc.ok : acc.ok,
              bugs:
                curr.lastError != null &&
                curr.lastError + 1000 * 60 * 60 > Date.now()
                  ? ++acc.bugs
                  : acc.bugs
            }),
            {
              isFine: true,
              total: this.devices.length,
              ok: 0,
              bugs: 0
            }
          )
        );
      });
    },
    getDevice(deviceId) {
      const device = this.devices.find(dev => dev.id === deviceId);
      if (device) {
        return device;
      }
      return this.devices[
        this.devices.push({
          id: deviceId,
          lastError: null,
          nodes: []
        }) - 1
      ];
    },
    getNode(deviceId, nodeId) {
      const device = this.getDevice(deviceId);
      const node = device.nodes.find(n => n.id === nodeId);
      if (node) {
        return node;
      }
      return device.nodes[
        device.nodes.push({
          id: nodeId,
          type: null,
          properties: []
        }) - 1
      ];
    },
    isErrorProperty(type, prop) {
      if (type === "psotnik_autodiscovery" || /psoc-/.test(type)) {
        return prop === "error";
      } else if (type === "ant-node") {
        return /-error/.test(prop);
      } else {
        return false;
      }
    },
    getProperty(deviceId, nodeId, propertyId) {
      const node = this.getNode(deviceId, nodeId);
      const property = node.properties.find(prop => prop.id === propertyId);
      if (property) {
        if (property.isError === null && node.type !== null) {
          this.$set(
            property,
            "isError",
            this.isErrorProperty(node.type, property.id)
          );
        }
        return property;
      }
      let isError = null;
      if (node.type !== null) {
        isError = this.isErrorProperty(node.type, propertyId);
      }
      return node.properties[
        node.properties.push({
          id: propertyId,
          isError,
          value: []
        }) - 1
      ];
    },
    getValue(deviceId, topic, payload) {
      let pattern = "$online";
      let params = mpat.exec(pattern, topic);
      if (params) {
        const isOnline = payload.toString() === "true";
        const device = this.getDevice(deviceId);
        this.$set(device, "online", isOnline);
        if (device.online) {
          this.$set(device, "lastPublish", Date.now());
        }
        return this.updateStatus();
      }
      const device = this.getDevice(deviceId);
      if (device.online) {
        this.$set(device, "lastPublish", Date.now());
      }
      pattern = "$stats/uptime";
      params = mpat.exec(pattern, topic);
      if (params) {
        const uptime = parseInt(payload.toString());
        this.$set(device, "uptime", uptime);
        return this.updateStatus();
      }
      pattern = "$nodes";
      params = mpat.exec(pattern, topic);
      if (params) {
        const nodeIds = payload.toString().split(",");
        nodeIds.forEach(id => this.getNode(deviceId, id));
        return this.updateStatus();
      }
      pattern = "+nodeId/$properties";
      params = mpat.exec(pattern, topic);
      if (params && params.nodeId[0] !== "$") {
        const properties = payload.toString().split(",");
        properties
          .map(prop =>
            prop.indexOf("[") > -1
              ? prop.slice(0, prop.indexOf("["))
              : prop.indexOf(":") > -1
              ? prop.slice(0, prop.indexOf(":"))
              : prop
          )
          .forEach(id => this.getProperty(deviceId, params.nodeId, id));
        return this.updateStatus();
      }
      pattern = "+nodeId/$type";
      params = mpat.exec(pattern, topic);
      if (params) {
        const type = payload.toString();
        const node = this.getNode(deviceId, params.nodeId);
        node.type = type;
        return this.updateStatus();
      }
      pattern = "+nodeId/+propertyId";
      params = mpat.exec(pattern, topic);
      if (params && params.nodeId[0] !== "$" && params.propertyId[0] !== "$") {
        const propertyId = params.propertyId.split("_");
        const property = this.getProperty(
          deviceId,
          params.nodeId,
          propertyId[0]
        );
        if (property.isError === true) {
          this.$set(
            this.getNode(deviceId, params.nodeId),
            "lastError",
            Date.now()
          );
          this.$set(this.getDevice(deviceId), "lastError", Date.now());
        }
        let index;
        if (propertyId.length > 1) {
          index = parseInt(propertyId[1]);
        } else {
          index = 0;
        }
        try {
          const v = [...property.value];
          v[index] = JSON.parse(payload.toString());
          this.$set(property, "value", [...v]);
        } catch (e) {
          const v = [...property.value];
          v[index] = payload.toString();
          this.$set(property, "value", [...v]);
        }
        return this.updateStatus();
      }
    },
    messageCallback(topic, payload) {
      const params = mpat.exec("/+user/+license/+device_id/#rest", topic);
      if (params) {
        const { user, license, device_id, rest } = params;
        if (
          user !== this.$store.user.state.username ||
          license !== this.license.grid
        ) {
          return;
        }
        const restString = rest.join("/");
        this.getValue(device_id, restString, payload);
      }
    }
  },
  store: { user: UserStore, mqtt: MqttStore },
  computed: {
    tree() {
      return this.devices.map(dev => ({
        label: dev.id,
        children: [
          {
            label: dev.id
          }
        ]
      }));
    }
  },
  data() {
    return {
      interval: null,
      cli: null,
      status: null,
      devices: []
    };
  },
  async destroyed() {
    clearInterval(this.interval);
    this.$store.mqtt.state.cli.removeListener("message", this.messageCallback);
  },
  created() {
    console.info(
      `Will sub: /${this.$store.user.state.username}/${this.license.grid}/#`
    );

    this.updateStatus();

    this.interval = setInterval(
      () => this.$nextTick(() => this.getStatus()),
      500
    );

    this.$store.mqtt.dispatch("subscribe", {
      topic: `/${this.$store.user.state.username}/${this.license.grid}/#`
    });

    this.$store.mqtt.state.cli.on("message", this.messageCallback);
  }
};
</script>

<style lang="scss" scoped>
.license-details {
  h3 {
    margin-top: 0;
  }
}
.expand {
  margin-left: -40px;
  margin-right: -40px;
}

.collapse-title {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
}
</style>
